import React from "react"

function Header() {
    return (
        <header>
            <img 
                src="http://www.pngall.com/wp-content/uploads/2016/03/Yao-Ming-Meme-PNG.png" 
                alt="Problem?"
            />
            <p>Random Meme Generator</p>
        </header>
    )
}

export default Header